import { ConfigValue } from '@/support/Config';

const environments: Environment[] = [
  {
    hostnames: [
      'localhost',
    ],
    config: {
      // GENERAL
      APP_TITLE: process.env.VUE_APP_TITLE || '',
      APP_VERSION: process.env.VUE_APP_VERSION || '',
      APP_ENV: process.env.VUE_APP_ENV || '',
      APP_PLATFORM: '', // todo remove this
      // ENDPOINTS
      APP_HOST_API: process.env.VUE_APP_HOST_API || 'http://img-api.app.test',
      APP_HOST_RPC: process.env.VUE_APP_HOST_RPC || 'http://img-api.app.test/rpc',
      APP_HOST_OAUTH: process.env.VUE_APP_HOST_OAUTH || 'http://img-api.app.test/oauth',
      // OAUTH (TODO USE THIS)
      // OAUTH_CLIENT_ID: process.env.VUE_APP_OAUTH_CLIENT_ID || 'VUE_APP_CLIENT_ID_ENV_UNDEFINED',
      // OAUTH_CLIENT_SECRET: process.env.VUE_APP_OAUTH_CLIENT_SECRET || 'VUE_APP_CLIENT_SECRET_ENV_UNDEFINED',
      // HEADERS
      APP_LOCAL_STORAGE_TOKEN: process.env.VUE_APP_LOCAL_STORAGE_TOKEN || 'com.atabix.hin_local',
      // APP_HEADER_FORCE_PASSWORD_CHANGE: process.env.VUE_APP_HEADER_FORCE_PASSWORD_CHANGE || 'x-force-password-change',
      // APP_HEADER_FORCE_SET_MFA: process.env.VUE_APP_HEADER_FORCE_SET_MFA || 'x-missing-mfa-token',
      // AUTH
      // AUTH_MFA_REQUIRED: process.env.VUE_APP_AUTH_MFA_REQUIRED || false,
    },
  },
  {
    hostnames: [
      'test.hin.schadeexpertise-groningen.nl',
    ],
    config: {
      // GENERAL
      APP_TITLE: '[TEST] Herstel in Natura',
      APP_VERSION: '0.1.0"',
      APP_ENV: 'test',
      APP_PLATFORM: '', // todo remove this
      // ENDPOINTS
      APP_HOST_API: 'https://tcmg.api.test.schadeexpertise-groningen.nl',
      APP_HOST_RPC: 'https://tcmg.api.test.schadeexpertise-groningen.nl/rpc',
      APP_HOST_OAUTH: 'https://tcmg.api.test.schadeexpertise-groningen.nl/oauth',
      // OAUTH (TODO USE THIS)
      // OAUTH_CLIENT_ID: process.env.VUE_APP_OAUTH_CLIENT_ID || 'VUE_APP_CLIENT_ID_ENV_UNDEFINED',
      // OAUTH_CLIENT_SECRET: process.env.VUE_APP_OAUTH_CLIENT_SECRET || 'VUE_APP_CLIENT_SECRET_ENV_UNDEFINED',
      // HEADERS
      APP_LOCAL_STORAGE_TOKEN: 'com.atabix.hin_test',
      // APP_HEADER_FORCE_PASSWORD_CHANGE: process.env.VUE_APP_HEADER_FORCE_PASSWORD_CHANGE || 'x-force-password-change',
      // APP_HEADER_FORCE_SET_MFA: process.env.VUE_APP_HEADER_FORCE_SET_MFA || 'x-missing-mfa-token',
      // AUTH
      // AUTH_MFA_REQUIRED: process.env.VUE_APP_AUTH_MFA_REQUIRED || false,
    },
  },
  {
    hostnames: [
      'acceptatie.hin.schadeexpertise-groningen.nl',
    ],
    config: {
      // GENERAL
      APP_TITLE: '[Acceptatie] Herstel in Natura',
      APP_VERSION: '0.1.0"',
      APP_ENV: 'acceptance',
      APP_PLATFORM: '', // todo remove this
      // ENDPOINTS
      APP_HOST_API: 'https://tcmg.api.acceptatie.schadeexpertise-groningen.nl',
      APP_HOST_RPC: 'https://tcmg.api.acceptatie.schadeexpertise-groningen.nl/rpc',
      APP_HOST_OAUTH: 'https://tcmg.api.acceptatie.schadeexpertise-groningen.nl/oauth',
      // OAUTH (TODO USE THIS)
      // OAUTH_CLIENT_ID: process.env.VUE_APP_OAUTH_CLIENT_ID || 'VUE_APP_CLIENT_ID_ENV_UNDEFINED',
      // OAUTH_CLIENT_SECRET: process.env.VUE_APP_OAUTH_CLIENT_SECRET || 'VUE_APP_CLIENT_SECRET_ENV_UNDEFINED',
      // HEADERS
      APP_LOCAL_STORAGE_TOKEN: 'com.atabix.hin_acceptatie',
      // APP_HEADER_FORCE_PASSWORD_CHANGE: process.env.VUE_APP_HEADER_FORCE_PASSWORD_CHANGE || 'x-force-password-change',
      // APP_HEADER_FORCE_SET_MFA: process.env.VUE_APP_HEADER_FORCE_SET_MFA || 'x-missing-mfa-token',
      // AUTH
      // AUTH_MFA_REQUIRED: process.env.VUE_APP_AUTH_MFA_REQUIRED || false,
    },
  },
  {
    hostnames: [
      'hin.schadeexpertise-groningen.nl',
    ],
    config: {
      // GENERAL
      APP_TITLE: 'Herstel in Natura',
      APP_VERSION: '0.1.0"',
      APP_ENV: 'production',
      APP_PLATFORM: '', // todo remove this
      // ENDPOINTS
      APP_HOST_API: 'https://production-tcmg.api.schadeexpertise-groningen.nl',
      APP_HOST_RPC: 'https://production-tcmg.api.schadeexpertise-groningen.nl/rpc',
      APP_HOST_OAUTH: 'https://production-tcmg.api.schadeexpertise-groningen.nl/oauth',
      // OAUTH (TODO USE THIS)
      // OAUTH_CLIENT_ID: process.env.VUE_APP_OAUTH_CLIENT_ID || 'VUE_APP_CLIENT_ID_ENV_UNDEFINED',
      // OAUTH_CLIENT_SECRET: process.env.VUE_APP_OAUTH_CLIENT_SECRET || 'VUE_APP_CLIENT_SECRET_ENV_UNDEFINED',
      // HEADERS
      APP_LOCAL_STORAGE_TOKEN: 'com.atabix.hin_production',
      // APP_HEADER_FORCE_PASSWORD_CHANGE: process.env.VUE_APP_HEADER_FORCE_PASSWORD_CHANGE || 'x-force-password-change',
      // APP_HEADER_FORCE_SET_MFA: process.env.VUE_APP_HEADER_FORCE_SET_MFA || 'x-missing-mfa-token',
      // AUTH
      // AUTH_MFA_REQUIRED: process.env.VUE_APP_AUTH_MFA_REQUIRED || false,
    },
  },
];

export default environments;

export interface Environment {
  hostnames: string[];
  config: { [key: string]: ConfigValue };
}
